import { render, staticRenderFns } from "./FamilyCheckDeleteModal.vue?vue&type=template&id=3b78e55d&lang=pug"
import script from "./FamilyCheckDeleteModal.vue?vue&type=script&lang=ts"
export * from "./FamilyCheckDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports